import { useEffect, useState, useContext } from "react";
import styles from "./ChatbotSectionStyle.module.css";

import FiltersComponent from "../FiltersComponents/FiltersComponent";
import FinalChatBotView from "../chatBot/FinalChatBotView";
import { GlobalStateContext } from "../../context/GlobalStateContext";

function ChatbotSection() {
  const { isChatting } = useContext(GlobalStateContext);
  
  const [isChatbotVisible, setIsChatbotVisible] = useState(false);
  const [isChatbotLoading] = useState(false); // Loader state
  const [hasFocusedOnce, setHasFocusedOnce] = useState(false); // Track if focus has happened

  const adjustFormAndWidget = () => {
    const form = document.querySelector(".footerBoxHandler");
    const textarea = form?.querySelector("textarea");
    const outerChatbotContainer = document.querySelector(
      ".chatbotOuterContainer"
    );

    if (form && textarea && !hasFocusedOnce) {
      if (!isChatbotVisible) {
        outerChatbotContainer.style.minHeight = "auto";
      }
      textarea.addEventListener("focus", () => {
        setIsChatbotVisible(true); // Switch to normal position on focus
        setHasFocusedOnce(true); // Prevent further focus triggers
        if (outerChatbotContainer) {
          outerChatbotContainer.style.minHeight = "";
          // Wait for the next render before scrolling
          setTimeout(() => {
            outerChatbotContainer.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }, 300);
        }
      });
    }
  };
  const enforceFormAdjustment = () => {
    // Continuously enforce the position every 500ms
    const interval = setInterval(() => {
      const form = document.querySelector(".footerBoxHandler");
      if (form) {
        adjustFormAndWidget();
      }
    }, 500);

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  };

  useEffect(() => {
    // initializeChatbot();

    // Wait for the chatbot to load, then adjust the form position
    const observer = new MutationObserver(() => {
      const form = document.querySelector(".footerBoxHandler");
      if (form) {
        adjustFormAndWidget();
        observer.disconnect(); // Stop observing once the form is found
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Enforce the adjustment as a fallback
    const cleanupEnforce = enforceFormAdjustment();

    return () => {
      observer.disconnect();
      cleanupEnforce();
    };
  }, [isChatbotVisible]); // Re-run the effect when the position state changes

  useEffect(() => {
    const setVh = () => {
      const vv = window.visualViewport;
      const height = vv ? vv.height : window.innerHeight;
      document.documentElement.style.setProperty("--app-vh", `${height}px`);
    };

    setVh();

    window.addEventListener("resize", setVh);
    window.visualViewport?.addEventListener("resize", setVh);
    window.visualViewport?.addEventListener("scroll", setVh); // iOS sometimes updates via scroll

    return () => {
      window.removeEventListener("resize", setVh);
      window.visualViewport?.removeEventListener("resize", setVh);
      window.visualViewport?.removeEventListener("scroll", setVh);
    };
  }, []);

  return (
    <div className={`${styles.chatbotOuterContainer} chatbotOuterContainer ${isChatting ? styles.chatBotExpanded : ''}`}>
      <FiltersComponent />
      {isChatbotLoading && (
        <div className="loader-container">
          <div className="loader"></div>
          <p>Loading chatbot...</p>
        </div>
      )}
      <div className={styles.chatboxSpacer}></div>
      <div id="aiiro-chat-bot-root">
        <FinalChatBotView />
      </div>
    </div>
  );
}

export default ChatbotSection;
